<template>
  <wsp-modal>
    <v-card class="pb-5" flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title>
            <span v-html="$t('parking.group.title')"></span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-list two-line>
          <template v-for="parking in parkingsArray">
            <v-list-tile :key="parking.id" @click="handleGoToDetail(parking)">
              <v-list-tile-avatar>
                <img :src="getParkingImage(parking)" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ parking.title }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ parking.address }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action v-if="parking.hasElectricSpots">
                <v-icon color="success">bolt</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import utilService from '@/services/utilService';

export default {
  name: 'ParkingListModal',
  components: {
    [WspModal.name]: WspModal
  },
  props: {
    parkingsArray: [],
    handleGoToDetail: null,
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  computed: {},
  data() {
    return {
      visible: true
    };
  },
  methods: {
    getParkingImage(parking) {
      let imageSize = utilService.getParkingImageSize(
        this.$vuetify.breakpoint.name,
        false
      );
      return `${parking.image}?${imageSize}`;
    },
  }
};
</script>
